/**
 *
 * Promotion
 *
 */

import React from 'react';
// import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Track } from 'utils/analytics';
import usePromotion from './usePromotion';

const Wrapper = styled(Modal)`
  font-size: large;
  .modal-body {
    font-weight: 500;
    padding: 3rem;
    text-align: center;
  }
`;

function Promotion() {
  const [promotion, setSeen] = usePromotion();
  if (!promotion) {
    return null;
  }
  const { id, prompt, action, link } = promotion;
  const handleHide = ev => {
    const clicked = ev && ev.target && ev.target.tagName === 'A';
    Track.event({
      category: 'Promotion',
      action: clicked ? 'Follow' : 'Hide',
      label: `Promo ${id}`,
      nonInteraction: true,
    });
    setSeen();
  };
  const actions = action.split(/\n/);
  return (
    <Wrapper show onHide={handleHide}>
      <Modal.Header closeButton>{prompt}</Modal.Header>
      <Modal.Body>
        <Link to={link} onClick={handleHide}>
          {actions.map(act => <div key={act}>{act}</div>)}
        </Link>
      </Modal.Body>
    </Wrapper>
  );
}

Promotion.propTypes = {};

export default Promotion;
